<div class="gridContainer">

    <h1 class="goBack" (click)="gotoVertrag()">Erhöhung der Bürgschaftslinie von {{ model.currVertrag.vertragHandle?.vsnrFormatiert }}</h1>

    <!-- ############################## Statische Erhöhung ################################## -->

    @if (model.staticTable) {
        <div class="pushMe">
            <!-- Fall: PRE SPE -->
            @if (page1) {
                <div>
                    <h2>1. Bürgschaftslinie wählen</h2>
                    <div class="tableContainer regularTable">
                        <div class="tableHead">
                            <div class="entryContainer">
                                <div class="tRow theadColumns">
                                    <div class="tCellflexible">
                                        <div class="tCell">Bürgschaftslinie</div>
                                    </div>
                                    <div class="tCellflexible">
                                        <div class="tCell">Höchstbetrag je Bürgschaft</div>
                                    </div>
                                    <div class="tCellflexible">
                                        <div class="tCell">Jahresbeitrag</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @for (line of model.staticTable.kreditlinien; track line; let i = $index) {
                            <div class="tableBody">
                                <div class="entryContainer">
                                    <div class="tRow">
                                        <div class="tCellflexible">
                                            <div class="tCell">
                                                <input type="radio"
                                                       name="f_buergschaftslinie"
                                                       [(ngModel)]="model.buergschaftslinieAuswahl.value"
                                                       value="{{ line.buergschaftsLinie }}"
                                                       [class.error]="model.buergschaftslinieAuswahl.valid === false"
                                                       id="f_buergschaftslinie_{{ line.buergschaftsLinie }}">
                                                <label for="f_buergschaftslinie_{{ line.buergschaftsLinie }}">
                                                    {{ line.buergschaftsLinie | formatMoney }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.hoechstBetragPercent }} %</div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.jahresBeitrag | formatMoney }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <h2>2. Geschäftsjahr wählen</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-25">
                                <input type="radio"
                                       id="f_geschaeftsjahr_aktuell_pluseins"
                                       name="f_geschaeftsjahr"
                                       [value]="model.years[0]"
                                       [(ngModel)]="model.geschaeftsjahr.value"
                                       [class.error]="model.geschaeftsjahr.valid === false"
                                       (blur)="validateField(model.geschaeftsjahr)">
                                <label for="f_geschaeftsjahr_aktuell_pluseins">{{ model.years[0] }}</label>
                            </div>
                            <div class="cell grid-75">
                                @if (model.years.length > 1) {
                                    <div>
                                        <input type="radio"
                                               id="f_geschaeftsjahr_aktuell"
                                               name="f_geschaeftsjahr"
                                               [value]="model.years[1]"
                                               [(ngModel)]="model.geschaeftsjahr.value"
                                               [class.error]="model.geschaeftsjahr.valid === false"
                                               (blur)="validateField(model.geschaeftsjahr)">
                                        <label for="f_geschaeftsjahr_aktuell">{{ model.years[1] }}</label>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="gotoVertrag()">Abbrechen</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="nextPageStatic()">Weiter</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (page2) {
                <div>
                    <h2>3. Zusammenfassung und Abschluss</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-100">
                                Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }}</strong> ab dem
                                Kalenderjahr <strong>{{ model.geschaeftsjahr.value }}</strong> eine Bürgschaftslinienerhöhung
                                um <strong>{{ getDifferenzStatic() | formatMoney }}</strong> auf eine Bürgschaftslinie in Höhe
                                von <strong>{{ this.model.staticTable.getEntry(this.model.buergschaftslinieAuswahl.value).buergschaftsLinie | formatMoney }}</strong>. Für die Bürgschaftslinie ist pro
                                Kalenderjahr ein Beitrag von <strong>{{ model.getBeitrag() | formatMoney }}</strong> zu zahlen.
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-100">
                                <input type="checkbox"
                                       id="f_bestaetigung_prespe"
                                       name="f_bestaetigung_prespe"
                                       value="Bestaetigung"
                                       [(ngModel)]="model.bestaetigung.value"
                                       [class.error]="model.bestaetigung.valid===false"
                                       (blur)="validateField(model.bestaetigung)">
                                <label for="f_bestaetigung_prespe">
                          <span> Hiermit bestätige ich, dass ich für das Unternehmen
                            <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}</strong>
                            handlungsbefugt und berechtigt bin, Darlehensgeschäfte
                            abzuschließen.
                          </span>
                                </label>
                                @if (model.bestaetigung.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.bestaetigung.errorMsg"></div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="previousPage()">Zurück</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="doBeantragen()">Bürgschaftslinienerhöhung verbindlich beantragen</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }


    <!-- ############################## Regelbasierte Erhöhung ################################## -->


    @if (model.ruledData) {
        <div class="pushMe">
            @if (page1) {
                <div>
                    <h2>1. Bürgschaftslinie festlegen</h2>
                    <div class="gridContainer fitGrid">
                        <div class="row">
                            <div class="cell grid-100">Bitte den Betrag festlegen, um den die Bürgschaftslinie für das aktuelle Kalenderjahr erhöht werden soll:</div>
                        </div>
                        <div class="row">
                            <div class="cell grid-25 alignr">
                                <label for="f_individuellerErhoehungsbetrag">um</label>
                            </div>
                            <div class="cell grid-25">
                                <div class="qty">
                                    <div class="qty-minus"
                                         (mousedown)="startMotorPrev()"
                                         (mouseup)="previousRuledBuergschaftslinie(); stopMotor()"
                                         (mouseout)="stopMotor()"></div>
                                    <input type="text"
                                           id="f_individuellerErhoehungsbetrag"
                                           name="f_individuellerErhoehungsbetrag"
                                           value=""
                                           placeholder="Betrag"
                                           [(ngModel)]="model.buergschaftslinieEingabe.value"
                                           [class.error]="model.buergschaftslinieEingabe.valid === false"
                                           (change)="displayBeitragRuledMessage();"
                                           (keyup)="triggerAmountChange($event);"
                                           (blur)="validateRuledBuergschaftslinie()">
                                    @if (model.buergschaftslinieEingabe.valid === false) {
                                        <div
                                            class="errorMessage"
                                            [innerHTML]="model.buergschaftslinieEingabe.errorMsg"></div>
                                    }
                                    <div class="qty-plus"
                                         (mousedown)="startMotorNext()"
                                         (mouseup)="nextRuledBuergschaftslinie(); stopMotor()"
                                         (mouseout)="stopMotor()"></div>
                                </div>
                            </div>
                            <div class="cell grid-50">
                                <label>EUR auf&nbsp;<strong>{{ model.getGesamthoeheRuled() | formatMoney }}</strong></label>
                            </div>
                        </div>
                        @for (line of model.ruledData.entries; track line; let i = $index) {
                            <div class="tableBody">
                                <div class="entryContainer">
                                    <div class="tRow">
                                        <div class="tCellflexible">
                                            <div class="tCell">
                                            </div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.hoechstBetragPercent }} %</div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.jahresBeitrag | formatMoney }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <h2>2. Bürgschaftslinie und Konditionen wählen</h2>
                    <div class="gridContainer formGrid fitGrid">
                        @if (model.ruledData.getProduktlinienAuswahl(model.produktlinie).length <= 2) {
                            <div class="row">
                                @for (auswahl of model.ruledData.getProduktlinienAuswahl(model.produktlinie); track auswahl; let i = $index) {
                                    <div class="cell grid-50">
                                        <input type="radio"
                                               name="f_tarif"
                                               id="f_tarif_{{ auswahl.produktlinie }}"
                                               value="{{ auswahl.produktlinie }}"
                                               [(ngModel)]="model.produktlinieAuswahl"
                                               (change)="checkProduktlinieAuswahl()">
                                        <label for="f_tarif_{{ auswahl.produktlinie }}"><strong>{{ auswahl.produktlinie }}</strong></label>
                                        <span class="radio-details">
                                  <span class="tarif-hinweis">
                                    Einmalbeitrag i.H.v. {{ auswahl.percent | formatPercent }} der<br>Jahresbürgschaftslinie
                                  </span>
                                </span>
                                    </div>
                                }
                            </div>
                        }
                        @if (model.ruledData.getProduktlinienAuswahl(model.produktlinie).length == 3) {
                            <div class="row">
                                @for (auswahl of model.ruledData.getProduktlinienAuswahl(model.produktlinie); track auswahl; let i = $index) {
                                    <div class="cell grid-33">
                                        <input type="radio"
                                               name="f_tarif"
                                               id="f_tarif_{{ auswahl.produktlinie }}"
                                               value="{{ auswahl.produktlinie }}"
                                               [(ngModel)]="model.produktlinieAuswahl"
                                               (change)="checkProduktlinieAuswahl()">
                                        <label for="f_tarif_{{ auswahl.produktlinie }}"><strong>{{ auswahl.produktlinie }}</strong></label>
                                        <span class="radio-details">
                                    <span class="tarif-hinweis">
                                      Einmalbetrag i.H.v. {{ auswahl.percent | formatPercent }} der<br>Jahresbürgschaftslinie
                                    </span>
                                  </span>
                                    </div>
                                }
                            </div>
                        }
                        <div class="row">
                            <div class="cell grid-100">
                                @if (this.beitragNotification != null) {
                                    <div>
                                        <elem-msg-line [notification]="beitragNotification"></elem-msg-line>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="gotoVertrag()">Abbrechen</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="nextPageRuled()">Weiter</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (page2) {
                <div>
                    <h2>3. Zusammenfassung und Abschluss</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-100">
                                Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }}</strong> für das
                                aktuelle Kalenderjahr eine Bürgschaftslinienerhöhung um <strong>{{ model.buergschaftslinieEingabe.value | correctAndFormatMoney }}
                            </strong> auf eine Bürgschaftslinie in Höhe von <strong>{{ model.getGesamthoeheRuled() | formatMoney }}</strong>.
                                Die Konditionen entsprechen der Produktlinie <strong>{{ model.produktlinieAuswahl }}</strong>.
                                Für die Bürgschaftslinie ist pro
                                Kalenderjahr ein Beitrag von <strong>{{ model.getBeitragRuled() | formatMoney }}</strong> zu zahlen.
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-100">
                                <input type="checkbox"
                                       id="f_bestaetigung_individuell_2"
                                       name="f_bestaetigung_individuell"
                                       value="Bestaetigung"
                                       [(ngModel)]="model.bestaetigung.value"
                                       [class.error]="model.bestaetigung.valid===false"
                                       (blur)="validateField(model.bestaetigung)">
                                <label for="f_bestaetigung_individuell_2">
                                    <span>Hiermit bestätige ich, dass ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}</strong> handlungsbefugt und berechtigt bin, Darlehensgeschäfte abzuschließen.</span>
                                </label>
                                @if (model.bestaetigung.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.bestaetigung.errorMsg"></div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="previousPage()">Zurück</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="doBeantragen()">Bürgschaftslinienerhöhung verbindlich beantragen</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }


    <!-- ############################## VHV-Kaution ################################## -->

    @if (model.vhvKautionTable) {
        <div class="pushMe">
            @if (page1) {
                <div>
                    <h2>1. Produktlinie wählen</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            @for (produktlinienAuswahl of this.model.vhvKautionNextProduktlinien; track produktlinienAuswahl) {
                                <div
                                    [ngClass]="['cell', this.model.vhvKautionNextProduktlinien.length === 3 ? 'grid-33' : 'grid-50']">
                                    <input type="radio"
                                           name="f_tarif"
                                           id="f_tarif_{{ produktlinienAuswahl }}"
                                           value="{{ produktlinienAuswahl }}"
                                           [(ngModel)]="model.produktlinieAuswahl"
                                           (change)="checkProduktlinieVhvKautionAuswahl()">
                                    <label for="f_tarif_{{ produktlinienAuswahl }}"><strong>{{ produktlinienAuswahl }}</strong></label>
                                </div>
                            }
                        </div>
                    </div>
                    <h2>2. Bürgschaftslinie wählen</h2>
                    <div class="tableContainer regularTable">
                        <div class="tableHead">
                            <div class="entryContainer">
                                <div class="tRow theadColumns">
                                    <div class="tCellflexible">
                                        <div class="tCell">Bürgschaftslinie</div>
                                    </div>
                                    <div class="tCellflexible">
                                        <div class="tCell">Einzellimit</div>
                                    </div>
                                    <div class="tCellflexible">
                                        <div class="tCell">Jahresbeitrag</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @for (line of model.vhvKautionTable.kreditlinien; track line; let i = $index) {
                            <div class="tableBody">
                                <div class="entryContainer">
                                    <div class="tRow">
                                        <div class="tCellflexible">
                                            <div class="tCell">
                                                <input type="radio"
                                                       name="f_buergschaftslinie"
                                                       id="f_buergschaftslinie_{{ line.buergschaftsLinie }}"
                                                       [(ngModel)]="model.buergschaftslinieAuswahl.value"
                                                       value="{{ line.buergschaftsLinie }}"
                                                       [class.error]="model.buergschaftslinieAuswahl.valid === false">
                                                <label for="f_buergschaftslinie_{{ line.buergschaftsLinie }}">
                                                    {{ line.buergschaftsLinie | formatMoney }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.einzellimit | formatMoney }}</div>
                                        </div>
                                        <div class="tCellflexible">
                                            <div class="tCell">{{ line.jahresBeitrag | formatMoney }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <h2>3. Geschäftsjahr wählen</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-25">
                                <input type="radio"
                                       id="f_vhvkaution_geschaeftsjahr_aktuell_pluseins"
                                       name="f_geschaeftsjahr"
                                       [value]="model.years[0]"
                                       [(ngModel)]="model.geschaeftsjahr.value"
                                       [class.error]="model.geschaeftsjahr.valid === false"
                                       (blur)="validateField(model.geschaeftsjahr)">
                                <label for="f_vhvkaution_geschaeftsjahr_aktuell_pluseins">{{ model.years[0] }}</label>
                            </div>
                            <div class="cell grid-75">
                                @if (model.years.length > 1) {
                                    <div>
                                        <input type="radio"
                                               id="f_vhvkaution_geschaeftsjahr_aktuell"
                                               name="f_geschaeftsjahr"
                                               [value]="model.years[1]"
                                               [(ngModel)]="model.geschaeftsjahr.value"
                                               [class.error]="model.geschaeftsjahr.valid === false"
                                               (blur)="validateField(model.geschaeftsjahr)">
                                        <label for="f_vhvkaution_geschaeftsjahr_aktuell">{{ model.years[1] }}</label>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="gotoVertrag()">Abbrechen</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="nextPageVhvKaution()">Weiter</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (page2) {
                <div>
                    <h2>3. Zusammenfassung und Abschluss</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-100">
                                Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }}</strong> ab dem
                                Kalenderjahr <strong>{{ model.geschaeftsjahr.value }}</strong> eine Bürgschaftslinienerhöhung
                                um <strong>{{ getDifferenzStatic() | formatMoney }}</strong> auf eine Bürgschaftslinie in Höhe
                                von <strong>{{ this.model.vhvKautionTable.getEntry(this.model.buergschaftslinieAuswahl.value).buergschaftsLinie | formatMoney }}</strong>.
                                Die Konditionen entsprechen der Produktlinie <strong>{{ model.produktlinieAuswahl }}</strong>.
                                Für die Bürgschaftslinie ist pro Kalenderjahr ein Beitrag von <strong>{{ model.getBeitragVhvKaution() | formatMoney }}</strong> zu zahlen.
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-100">
                                <input type="checkbox"
                                       id="f_vhvkaution_bestaetigung_prespe"
                                       name="f_bestaetigung_prespe"
                                       value="Bestaetigung"
                                       [(ngModel)]="model.bestaetigung.value"
                                       [class.error]="model.bestaetigung.valid===false"
                                       (blur)="validateField(model.bestaetigung)">
                                <label for="f_vhvkaution_bestaetigung_prespe">
                                            <span> Hiermit bestätige ich, dass ich für das Unternehmen
                                              <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}</strong>
                                              handlungsbefugt und berechtigt bin, Darlehensgeschäfte
                                              abzuschließen.
                                            </span>
                                </label>
                                @if (model.bestaetigung.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.bestaetigung.errorMsg"></div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="previousPage()">Zurück</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="doBeantragen()">Bürgschaftslinienerhöhung verbindlich beantragen</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    <!-- ############################## Individuelle Erhöhung ################################## -->


    @if (model.individual) {
        <div class="pushMe">
            @if (page1) {
                <div>
                    <h2>1. Individuelle Bürgschaftslinie</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-50 alignr">
                                <label for="f_individuellerErhoehungsbetrag_2">Betrag, um den die Bürgschaftslinie erhöht werden soll:</label>
                            </div>
                            <div class="cell grid-25">
                                <input type="text"
                                       id="f_individuellerErhoehungsbetrag_2"
                                       name="f_individuellerErhoehungsbetrag"
                                       value=""
                                       placeholder="Betrag"
                                       [(ngModel)]="model.buergschaftbetrag.value"
                                       [class.error]="model.buergschaftbetrag.valid === false"
                                       (keyup)="triggerAmountChangeIndividual($event);"
                                       (blur)="validateField(model.buergschaftbetrag)">
                                @if (model.buergschaftbetrag.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.buergschaftbetrag.errorMsg"></div>
                                }
                            </div>
                            <div class="cell grid-25">
                                <label>EUR</label>
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="gotoVertrag()">Abbrechen</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="nextPageIndividual()">Weiter</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (page2) {
                <div>
                    <h2>2. Zusammenfassung und Abschluss</h2>
                    <div class="gridContainer formGrid fitGrid">
                        <div class="row">
                            <div class="cell grid-100">
                                Hiermit beantrage ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}, {{ model.currVertrag.vertragHandle.vsnrFormatiert }}</strong> für das
                                aktuelle Kalenderjahr eine Bürgschaftslinienerhöhung um <strong>{{ model.buergschaftbetrag.value | correctAndFormatMoney }}
                            </strong> auf eine Bürgschaftslinie in Höhe von <strong>{{ model.getGesamthoehe() | formatMoney }}</strong>.
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-100">
                                <input type="checkbox"
                                       id="f_bestaetigung_individuell"
                                       name="f_bestaetigung_individuell"
                                       value="Bestaetigung"
                                       [(ngModel)]="model.bestaetigung.value"
                                       [class.error]="model.bestaetigung.valid === false"
                                       (blur)="validateField(model.bestaetigung)">
                                <label for="f_bestaetigung_individuell"> <span> Hiermit
                                                bestätige ich, dass ich für das Unternehmen <strong>{{ partner.vornameOderName2.value }} {{ partner.nachnameOderName1.value }}</strong> handlungsbefugt und berechtigt
                                                bin, Darlehensgeschäfte abzuschließen.
                                              </span>
                                </label>
                                @if (model.bestaetigung.valid === false) {
                                    <div
                                        class="errorMessage"
                                        [innerHTML]="model.bestaetigung.errorMsg"></div>
                                }
                            </div>
                        </div>
                        <div class="row trenner"></div>
                        <div class="row">
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="TERTIARY" (click)="previousPage()">Zurück</elem-button>
                            </div>
                            <div class="cell grid-50"></div>
                            <div class="cell grid-25">
                                <elem-button class="expand" buttonRole="PRIMARY" (click)="doBeantragen()">Bürgschaftslinienerhöhung verbindlich beantragen</elem-button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }

    @if (page3) {
        <div>
            <h2>
                Vielen Dank.
                <print-kreditlinie-antrag [model]="model" [partner]="partner"></print-kreditlinie-antrag>
            </h2>
            <div class="gridContainer">
                <div class="row">
                    <div class="cell grid-100">Wir haben Ihren Antrag erhalten.</div>
                </div>
            </div>
        </div>
    }

    @if (page2) {
        <div>
            <print-kreditlinie-antrag [model]="model" [partner]="partner" [invisibleButton]="true"></print-kreditlinie-antrag>
        </div>
    }

    @if (model.keineErhoehung) {
        <div>
            <elem-msg-line [notification]="keineErhoehungNotification"></elem-msg-line>
        </div>
    }

</div>
